var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12.15 5.985.107.024.11-.003c1.817-.03 4.622-.068 7.128-.078 2.548-.012 4.685.005 5.242.07.183.022.268.07.304.096.035.025.06.055.08.102.024.051.041.124.045.212.002.041.001.08-.002.116l-2.424 4.283c-1.564-.005-3.034-.028-4.096-.082-2.888-.148-3.918 1.357-4.072 2.129-.37.71-1.703 3.202-4.073 7.497-1.568 2.84-3.06 4.622-4.122 5.62a8.87 8.87 0 0 1-1.163-.026c-.97-.088-1.812-.351-2.334-.821-1.066-.96-1.039-2.385-.865-3.042a671.75 671.75 0 0 1 4.356-8.316c1.606-3.007 3.04-5.606 3.593-6.401.997-1.433 2.04-1.417 2.186-1.385zM5.22 26.878c-1.076-.087-2.197-.378-2.958-1.063C.78 24.482.904 22.545 1.15 21.742 3.342 17.485 8.02 8.543 9.204 6.84c1.185-1.703 2.592-1.882 3.147-1.758 3.64-.062 11.237-.148 12.496 0 1.258.148 1.326 1.234 1.203 1.758l-2.247 3.969c2.375-.007 4.801-.048 6.226-.082.585-.093 1.517.314.554 2.684-.962 2.37-4.659 8.515-6.386 11.292-.494.74-2.148 2.221-4.813 2.221H5.13c.03-.014.06-.03.09-.047z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUft);
export default __webpack_public_path__ + "static/media/UFT.25e20a87398acaffd84f00f4c8738054.svg";
export { ForwardRef as ReactComponent };